export const VIDEO_CREATOR_LAYOUT = {
  modelAreaHeight: 266,
  modelAreaHeightExpanded: 390,
  modelAreaHeightLargeScreen: 354, // Expanded size minus 36px for show more/less
  modelAreaHeightMobile: 127,

  /** When `window.innerHeight` is below this, show more/less is shown */
  windowSizeThreshold: 1000,

  propertiesHeightNoAudio: 71,
  promptShortNoError: 148,
  /** Extra height when error message is shown */
  promptErrorDelta: 40,
  /** Extra height when prompt is long */
  promptLongDelta: 100,
  /** Mobile doesn't show file upload, so needs less space */
  promptMobileDelta: 40,
  /** Extra properties height when audio model is selected */
  propertiesAudioDelta: 74,
} as const;
